module.exports = __webpack_public_path__ + "static1/img/91ecb50c912759e193bc3a1aa77f5fc.4af2a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/91ecb50c912759e193bc3a1aa77f5fc.png
// module id = 7Kgl
// module chunks = 1